"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ContentPattern = void 0;
var _debounce = _interopRequireDefault(require("@sd-utility/debounce"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _brandLogos = require("../../fuse-brand-logos/src/brand-logos");
var _config = _interopRequireDefault(require("./config"));
var _styledContentPattern = require("./styled-content-pattern");
var _excluded = ["brandLogo", "children", "className", "dataAnalyticsId", "dataTestId", "icon", "imageWrapper", "picture", "videoPlayerSlot"],
  _excluded2 = ["fallbackSource"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useEffect = _react["default"].useEffect,
  useRef = _react["default"].useRef,
  useState = _react["default"].useState;
var displayName = 'ContentPattern';
var propTypes = {
  brandLogo: _propTypes["default"].shape({
    alt: _propTypes["default"].string,
    brand: _propTypes["default"].oneOf(Object.keys(_brandLogos.logos))
  }),
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  className: _propTypes["default"].string,
  dataAnalyticsId: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  icon: _propTypes["default"].element,
  imageWrapper: _propTypes["default"].shape({
    imageAlignment: _propTypes["default"].oneOf(['center', 'top']),
    imagePosition: _propTypes["default"].oneOf(['left', 'right']),
    imageRatio: _propTypes["default"].oneOf(_config["default"]) // ['1:1', '16:9', '4:3', '5:4', '3:4']
  }),
  picture: _propTypes["default"].shape({
    alt: _propTypes["default"].string,
    fallbackSource: _propTypes["default"].string,
    fetchPriority: _propTypes["default"].oneOf(['auto', 'low', 'high']),
    isLazy: _propTypes["default"].bool,
    sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      srcSet: _propTypes["default"].string,
      type: _propTypes["default"].string
    }))
  }),
  videoPlayerSlot: _propTypes["default"].node
};
var defaultProps = {
  brandLogo: undefined,
  className: '',
  dataAnalyticsId: '',
  dataTestId: '',
  icon: undefined,
  imageWrapper: {
    imageAlignment: 'center',
    imagePosition: 'left',
    imageRatio: '1:1'
  },
  picture: {
    alt: '',
    fallbackSource: '',
    fetchPriority: 'auto',
    isLazy: false,
    position: 'left',
    sources: [{
      srcSet: '',
      type: ''
    }]
  },
  videoPlayerSlot: undefined
};
var ContentPattern = exports.ContentPattern = forwardRef(function (_ref, ref) {
  var brandLogo = _ref.brandLogo,
    children = _ref.children,
    className = _ref.className,
    dataAnalyticsId = _ref.dataAnalyticsId,
    dataTestId = _ref.dataTestId,
    icon = _ref.icon,
    imageWrapper = _ref.imageWrapper,
    picture = _ref.picture,
    videoPlayerSlot = _ref.videoPlayerSlot,
    others = _objectWithoutProperties(_ref, _excluded);
  // Refs
  var contentWrapperRef = useRef();
  var ctaContainerRef = useRef();
  var contentBodyRef = useRef();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    copyWrapperWidth = _useState2[0],
    setCopyWrapperWidth = _useState2[1];
  // Desctructure object
  var imageAlignment = imageWrapper.imageAlignment,
    imagePosition = imageWrapper.imagePosition,
    imageRatio = imageWrapper.imageRatio;
  var fallbackSource = picture.fallbackSource,
    restPicture = _objectWithoutProperties(picture, _excluded2);
  var isPicture = !!fallbackSource;
  // Array of children passed either as cta or default content body
  var contentBody = [];
  var contentCTA = [];
  var contentButton = [];

  // Sort children into categories of either contentBody, contentCTA or contentButton
  _react["default"].Children.forEach(children, function (child) {
    if (/*#__PURE__*/_react["default"].isValidElement(child) && child.props.slot === 'cta' && child.props.type === 'button') {
      contentButton.push(child);
    } else if (/*#__PURE__*/_react["default"].isValidElement(child) && child.props.slot === 'cta' && child.props.type !== 'button') {
      contentCTA.push(child);
    } else {
      contentBody.push(child);
    }
  });
  useEffect(function () {
    setCopyWrapperWidth(contentBodyRef.current.offsetWidth);
    var handleResize = (0, _debounce["default"])(function () {
      setCopyWrapperWidth(contentBodyRef.current.offsetWidth);
    }, 200);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledContentPattern, _extends({}, others, {
    className: className,
    "data-analyticsid": dataAnalyticsId,
    "data-testid": dataTestId,
    imageAlignment: imageAlignment,
    imagePosition: imagePosition,
    ref: ref
  }), videoPlayerSlot ? /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledVideoWrapper, null, videoPlayerSlot) : /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledImageWrapper, {
    imageRatio: imageRatio,
    isPicture: isPicture
  }, picture && picture.fallbackSource && /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledPicture, _extends({
    imageRatio: imageRatio,
    fallbackSource: fallbackSource
  }, restPicture)), icon && !(picture !== null && picture !== void 0 && picture.fallbackSource) && !brandLogo && /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledIconWrapper, null, icon), brandLogo && !(picture !== null && picture !== void 0 && picture.fallbackSource) && !icon && /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledBrandLogos, brandLogo)), /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledContentWrapper, {
    ref: contentWrapperRef
  }, /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledContentBody, {
    ref: contentBodyRef
  }, contentBody), contentCTA.length > 0 && /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledContentCTA, {
    ref: ctaContainerRef
  }, contentCTA), contentButton.length === 2 && /*#__PURE__*/_react["default"].createElement(_styledContentPattern.StyledResizeStackedCTA, {
    parentContentWidth: copyWrapperWidth
  }, contentButton)));
});
ContentPattern.defaultProps = defaultProps;
ContentPattern.displayName = displayName;
ContentPattern.propTypes = propTypes;
var _default = exports["default"] = ContentPattern;